// extracted by mini-css-extract-plugin
module.exports = {"icon":"profile-menu_icon__6LmjJ","text":"profile-menu_text__qzQuh","activeText":"profile-menu_activeText__PUmoE","arrow":"profile-menu_arrow__g179n"};